import * as swcHelpers from '@swc/helpers';
import { getProductType } from './get-shopping-list-product-type.js';

const mapShoppingListToWishlistItems = (shoppingList)=>{
    if (shoppingList) {
        return shoppingList === null || shoppingList === void 0 ? void 0 : shoppingList.items.map((item)=>{
            let additionalFields = {};
            switch(item.product.__typename){
                case 'AccessoriesProduct':
                case 'FrameProduct':
                case 'PrescriptionGlassesPackageOptionsProduct':
                case 'ReadyReaderProduct':
                case 'SunglassesProduct':
                case 'ContactLensProduct':
                case 'LensTypeProduct':
                case 'PrescriptionGlassesPackageProduct':
                case 'SolutionProduct':
                    const matchingVariantIndex = item.product.variants.findIndex((variant)=>{
                        return variant.sku === item.sku;
                    });
                    const matchingVariant = item.product.variants[matchingVariantIndex];
                    if (matchingVariant) {
                        var ref, ref1, ref2, ref3, ref4;
                        additionalFields = {
                            imageSrc: (ref = matchingVariant.media.images[0]) === null || ref === void 0 ? void 0 : ref.url,
                            originalPrice: (ref1 = matchingVariant.prices.originalPrice) === null || ref1 === void 0 ? void 0 : ref1.amount,
                            discountedPrice: (ref2 = matchingVariant.prices.discountedPrice) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.amount,
                            currencyCode: (ref4 = matchingVariant.prices.originalPrice) === null || ref4 === void 0 ? void 0 : ref4.currencyCode
                        };
                    }
                    break;
                default:
                    additionalFields = {};
                    break;
            }
            const shoppinglistItem = swcHelpers.objectSpread({
                sku: item.sku,
                name: item.name,
                productType: getProductType(item.product.__typename),
                slug: item.product.slug
            }, additionalFields);
            return shoppinglistItem;
        });
    }
    return [];
};

export { mapShoppingListToWishlistItems };
//# sourceMappingURL=shopping-list-to-wishlist-mapper.js.map
